import { useState } from "react";
const styles = {
  button: {
    backgroundColor: "#222",
    color: "#FFF",
    padding: "10px 15px",
    borderRadius: "0px",
    cursor: "pointer",
    border: "0px",
  },
};
const Icon = ({ text, icon }) => {
  return icon ? (
    <>
      {text} <i className="fas fa-shopping-cart"></i>
    </>
  ) : (
    <>
      {text} <i className="fas fa-check" />
    </>
  );
};
export default function ButtonToCart({ product, addToCart }) {
  const [textAddToCart, setTextAddToCart] = useState("Agregar al carrito");
  const [flag, setFlag] = useState(true);
  return (
    <div>
      <button
        style={styles.button}
        onClick={async () => {
          setFlag(false);
          setTextAddToCart("Agregado al carrito");
          setTimeout(() => {
            addToCart(product);
            setFlag(true);
            setTextAddToCart("Agregar al carrito");
          }, 1000);
        }}
      >
        <Icon text={textAddToCart} icon={flag} />
      </button>
    </div>
  );
}
